import { v4 as uuidv4 } from "uuid";
export class ProjectReportEntryModel {
    constructor() {
        this.id = uuidv4();
        this.startTime = null;
        this.endTime = null;
        this.dateAsString = "";
        this.employeeId = null;
        this.employeeName = "";
        this.employeeDisplayString = "";
        this.taskDisplayString = "";
        this.description = "";
        this.startTimeTzFormatted = "";
        this.endTimeTzFormatted = "";
        this.totalTimeInHours = "";
    }
}
export default class ProjectReportEntry extends ProjectReportEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
